module.exports = __webpack_public_path__ + "media/Ultime Grida Dalla Monde.c77d4c4c.mp3";